import { ColumnType } from '@thoughtspot/ts-chart-sdk';
import _ from 'lodash';
import { ChartSpecificColumnTypeToColumnTypeMap, ColumnTypeToEffectiveTypeMap, } from '../events/ts-to-chart/get-data-query/types';
import { AnswerColumnEffectiveType, ChartSpecificColumnType, } from '../types/prism';
import { extractColumnIdsFromDimension } from './custom-chart-model.utils';
const DATA_LIMIT_EXCEED_ERROR_CODES = ['11049', '11050', '11051', '11052', '11053'];
const hasErrorCode = (error) => {
    return (typeof error === 'object' &&
        error !== null &&
        'code' in error &&
        (typeof error.code === 'string' || typeof error.code === 'number'));
};
export const isDataLimitExceedError = (error) => {
    return hasErrorCode(error) && DATA_LIMIT_EXCEED_ERROR_CODES.includes(String(error.code));
};
const PRISM_DIMENSIONS = {
    x: 'x',
    y: 'y',
    measureValues: 'measureValues',
};
export const mapSDKQueryToDataQueryInput = (queries) => {
    if (_.isEmpty(queries)) {
        return null;
    }
    const dataQueryInput = {
        queries: queries.map((query) => {
            const { queryColumns } = query;
            return {
                query: queryColumns.map((col) => {
                    let type = ColumnTypeToEffectiveTypeMap[col.type];
                    if (col.type === ColumnType.VIRTUAL) {
                        type =
                            ChartSpecificColumnTypeToColumnTypeMap[col.chartSpecificColumnType];
                    }
                    let dimension;
                    if (col.isMeasureValue) {
                        dimension = PRISM_DIMENSIONS.measureValues;
                    }
                    else if (type === AnswerColumnEffectiveType.Measure) {
                        dimension = PRISM_DIMENSIONS.y;
                    }
                    else {
                        dimension = PRISM_DIMENSIONS.x;
                    }
                    return {
                        id: col.id,
                        type,
                        dimension,
                    };
                }),
                queryParam: {
                    pagination: {
                        offset: query.queryParams?.offset ?? undefined,
                        size: query.queryParams?.size ?? undefined,
                    },
                },
            };
        }),
    };
    return dataQueryInput;
};
export const convertCustomChartConfigToDataQueryInput = (customChartConfig, allColumns, queryParams, shouldIncludeMNMVColumns = true) => {
    if (!customChartConfig?.length) {
        return null;
    }
    const measureValueColumn = allColumns.find(column => column.chartSpecificColumnType === ChartSpecificColumnType.MeasureValues);
    const measureNameColumn = allColumns.find(column => column.chartSpecificColumnType === ChartSpecificColumnType.MeasureNames);
    const dataQueryInput = {
        queries: customChartConfig.map(config => {
            let isMeasureNameColumnIncluded = false;
            let isMeasureValueColumnIncluded = false;
            let isMeasureColumnIncluded = false;
            const queries = [];
            config.dimensions.map(dimension => {
                const columns = extractColumnIdsFromDimension(dimension);
                columns.map(columnId => {
                    const answerColumn = allColumns.find(column => column.id === columnId);
                    if (answerColumn.type === AnswerColumnEffectiveType.Measure) {
                        isMeasureColumnIncluded = true;
                    }
                    if (answerColumn.chartSpecificColumnType === ChartSpecificColumnType.MeasureValues) {
                        if (!shouldIncludeMNMVColumns) {
                            return;
                        }
                        isMeasureValueColumnIncluded = true;
                    }
                    if (answerColumn.chartSpecificColumnType === ChartSpecificColumnType.MeasureNames) {
                        if (!shouldIncludeMNMVColumns) {
                            return;
                        }
                        isMeasureNameColumnIncluded = true;
                    }
                    let dimension = answerColumn.type === AnswerColumnEffectiveType.Measure ? PRISM_DIMENSIONS.y : PRISM_DIMENSIONS.x;
                    if (shouldIncludeMNMVColumns && answerColumn.type === AnswerColumnEffectiveType.Measure) {
                        dimension = PRISM_DIMENSIONS.measureValues;
                    }
                    queries.push({
                        id: answerColumn.id,
                        type: answerColumn.type,
                        dimension: dimension,
                    });
                });
            });
            if (shouldIncludeMNMVColumns && isMeasureColumnIncluded) {
                if (measureNameColumn && !isMeasureNameColumnIncluded) {
                    queries.push({
                        id: measureNameColumn.id,
                        type: AnswerColumnEffectiveType.Attribute,
                        dimension: PRISM_DIMENSIONS.x,
                    });
                }
                if (measureValueColumn && !isMeasureValueColumnIncluded) {
                    queries.push({
                        id: measureValueColumn.id,
                        type: AnswerColumnEffectiveType.Measure,
                        dimension: PRISM_DIMENSIONS.y,
                    });
                }
            }
            return {
                query: queries,
                queryParam: {
                    pagination: {
                        offset: queryParams.offset,
                        size: queryParams.size,
                    },
                },
            };
        })
    };
    return dataQueryInput;
};
//# sourceMappingURL=data-query.util.js.map